import { render, staticRenderFns } from "./snapshots.vue?vue&type=template&id=638d28ee"
import script from "./snapshots.vue?vue&type=script&lang=js"
export * from "./snapshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports